import React from 'react';
import styled from 'styled-components';
import {asignarContactos, removerContactos} from "../../../endpoints"
import Swal from "sweetalert2";
const CardContactGroup =
  ({
    userId,
    group,
    getContactsGroupsAsync,
    refresh,
    setRefresh
  }) => {
    const asignarContactosBtn = () => {
      if(group.assignedUsers !== "SIN ASIGNAR"){
        Swal.fire({
          icon: "question",
          title:`Se removeran estos contactos de ${group.assignedUsers} . <br/>¿Desea continuar?`,
          
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
      
          confirmButtonColor: "#003049",
          cancelButtonColor: "#570c11",
          customClass: {
            title: 'my-custom-title-class'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            // Si se hace clic en el botón "Sí"
            // Aquí puedes realizar alguna acción adicional si es necesario
            console.log("Se hizo clic en Sí");
            removerContactos({
              groupId:group.id,
              userId:userId
            }).then((res) => {
              if(res.status === 200){
                console.log("termino")
      
                Swal.fire({
                  icon: "success",
                  title: "Contactos removidos correctamente.",
                  
                  // showCancelButton: true,
                  // cancelButtonText: "Cancelar",
                  confirmButtonText: "Listo",
              
                  confirmButtonColor: "#003049",
                  cancelButtonColor: "#570c11",
                  customClass: {
                    title: 'my-custom-title-class'
                  }
                })
                getContactsGroupsAsync()
                setRefresh({
                  ...refresh,
                  value: refresh.value ++,
                })
              }
            })
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Si se hace clic en el botón "Cancelar" o se cierra el cuadro de diálogo
            // Aquí puedes realizar alguna acción adicional si es necesario

            console.log("Se hizo clic en Cancelar o se cerró el cuadro de diálogo");
            setRefresh({
              ...refresh,
              value: refresh.value ++,
            })
          }
        });
      }else {
        asignarContactos({
          groupId:group.id,
          userId:userId
        }).then((res) => {
          if(res.status === 200){
            console.log("termino")
  
            Swal.fire({
              icon: "success",
              title: "Contactos asignados correctamente.",
              
              // showCancelButton: true,
              // cancelButtonText: "Cancelar",
              confirmButtonText: "Listo",
          
              confirmButtonColor: "#003049",
              cancelButtonColor: "#570c11",
              customClass: {
                title: 'my-custom-title-class'
              }
            })
            getContactsGroupsAsync()
            setRefresh({
              ...refresh,
              value: refresh.value ++,
            })
          }
        })
      }
   
    }
    return (

      <DivRow>
        <DivColumn>
          <Text>
            {group.name}
          </Text>
          <Text>
            {"Contactos: "}{group.totalContacts}
          </Text>
          <Text>
            {"Estado: "}{group.assignedUsers}
          </Text>
        </DivColumn>
        {
          group.assignedUsers !== "SIN ASIGNAR" ? 
          <BtnAsignar
          style={{
            backgroundColor: "#6f120f"
          }}
          onClick={asignarContactosBtn}>
          Remover
        </BtnAsignar>
        :
        <BtnAsignar onClick={asignarContactosBtn}>
        Asignar
      </BtnAsignar>
        }
  

      </DivRow>
    );
  };

export default CardContactGroup;

const DivColumn = styled.div`
width:250px;
height:auto;
display:flex;
flex-direction:column;
align-items:flex-start;
gap:5px;
`

const TextSpan = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
max-width:100px;
overflow-x: scroll;
&::-webkit-scrollbar {
  height: 4px;
  width: 3px;
  background-color: transparent !important;
}

&::-webkit-scrollbar-track {
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background-color: #003049 !important;
  border-radius: 8px;
}
`;
const CalendarIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  
`;

const BtnAsignar = styled.div`
background-color: #17415d;
border-radius: 8px;
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
cursor: pointer;
height: 30px;
margin: 0px 16px 0px 16px;
width: auto;
align-self: center;
align-content: center;
gap:8px;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 12px;
  color: #FFFFFF;
  padding:4px 8px;
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content: center;
  
  &:focus {
    // border-color: #380418;
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    opacity: 0.9;
    // transform:scale(0.98)
  }
`;

const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: '#07082c' ;

`;
const DivRow = styled.div`
width: -webkit-fill-available;
padding: 8px;

display: flex;
flex-direction: row;
gap: 5px;
height: auto;
align-content: flex-start;
justify-content: space-between;
align-items: center;
border-top: 1.5px solid #e1e3ea;
box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
cursor: pointer;
background-color: 'transparent' ;
transition: all 0.3s ease-in-out;
&:hover{
    box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    // height:8vh;

    will-change: transform;
}
&:active{

  

    will-change: transform;
    
}
`;


const IconItem = styled.img`
width:24px;
height:24px;
min-height:24px;
min-width:24px;
padding:5px;
border-radius:50%;
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
cursor:pointer;
&:hover{
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
    background-color: #00304954;
    border-radius:50%;
    padding:5px;
}
&:active{
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
    background-color: #00304954;
    border-radius:50%;
    padding:5px;
}
`;
